import { render } from "./hero.vue?vue&type=template&id=70dbdf5f&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=70dbdf5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70dbdf5f"

export default script